import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class IntegrationMainsmsService extends BaseService {
  protected baseUrl = '/debts/integration/main-sms';
}
